// import storage from 'redux-persist/lib/storage';
// import { combineReducers } from 'redux';
// import {
//     persistReducer,
//     FLUSH,
//     REHYDRATE,
//     PAUSE,
//     PERSIST,
//     PURGE,
//     REGISTER,
// } from 'redux-persist';
// import LoginReducer from './LoginReducer';
// import AuthenticationReducer from './AuthenticationReducer';
// import loadingReducer from './loadingReducer';
// import { configureStore } from '@reduxjs/toolkit';
// import MailSentReducer from './MailSentReducer';
// import PendingReducer from './PendingReducer';
// import AcceptedReducer from './AcceptedReducer';
// import FilterReducer from './FilterReducer';
// import V2PRMReducer from './V2PRMReducer';
// import KYCRequestReducer from './KYCRequestReducer';
// import CustomerAuthentication from './CustomerAuthentication';
// import CustomerDataReducer from './CustomerDataReducer';
// import DetailsReducer from './DetailsReducer';
// import StepsReducer from './StepsReducer';
// import SuccessReducer from './SuccessReducer';
// import CustomerBankDetailsReducer  from './CustomerBankDataReducer';


// const persistConfig = {
//     key: 'onboarding',
//     storage,
// };
// const reducers = combineReducers({
//     login: LoginReducer,
//     authentication: AuthenticationReducer,
//     loading: loadingReducer,
//     mailSent: MailSentReducer,
//     pending: PendingReducer,
//     accepted: AcceptedReducer,
//     filterData: FilterReducer,
//     v2pRMData: V2PRMReducer,
//     kycRequestData: KYCRequestReducer,
//     customerAuthenticate: CustomerAuthentication,
//     customerData: CustomerDataReducer,
//     details: DetailsReducer,
//     stepsData: StepsReducer,
//     successPage: SuccessReducer,
//     customerBankDetails:CustomerBankDetailsReducer
// });

// const persistedReducer = persistReducer(persistConfig, reducers);

// export const store = configureStore({
//     reducer: persistedReducer,
//     middleware: (getDefaultMiddleware) =>
//         getDefaultMiddleware({
//             serializableCheck: {
//                 ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
//             },
//         }),
// });


import storage from 'redux-persist/lib/storage';
import { combineReducers } from 'redux';
import {
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
} from 'redux-persist';
import { configureStore } from '@reduxjs/toolkit';

// Import your reducers
import LoginReducer from './LoginReducer';
import AuthenticationReducer from './AuthenticationReducer';
import loadingReducer from './loadingReducer';
import MailSentReducer from './MailSentReducer';
import PendingReducer from './PendingReducer';
import AcceptedReducer from './AcceptedReducer';
import FilterReducer from './FilterReducer';
import V2PRMReducer from './V2PRMReducer';
import KYCRequestReducer from './KYCRequestReducer';
import CustomerAuthentication from './CustomerAuthentication';
import CustomerDataReducer from './CustomerDataReducer';
import DetailsReducer from './DetailsReducer';
import StepsReducer from './StepsReducer';
import SuccessReducer from './SuccessReducer';
import CustomerBankDetailsReducer from './CustomerBankDataReducer';

import encryptionTransform from './encryptionTransform';

const persistConfig = {
    key: 'onboarding',
    storage,
    transforms: [encryptionTransform],
};

const reducers = combineReducers({
    login: LoginReducer,
    authentication: AuthenticationReducer,
    loading: loadingReducer,
    mailSent: MailSentReducer,
    pending: PendingReducer,
    accepted: AcceptedReducer,
    filterData: FilterReducer,
    v2pRMData: V2PRMReducer,
    kycRequestData: KYCRequestReducer,
    customerAuthenticate: CustomerAuthentication,
    customerData: CustomerDataReducer,
    details: DetailsReducer,
    stepsData: StepsReducer,
    successPage: SuccessReducer,
    customerBankDetails: CustomerBankDetailsReducer
});

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }),
});
